<div class="custom-modal">
    <div class="header" *ngIf="data.titulo">
        <h1 mat-dialog-title>{{data.titulo}}</h1>
        <mat-icon mat-dialog-close>close</mat-icon>
    </div>
    <mat-divider *ngIf="data.titulo"></mat-divider>
    <div mat-dialog-content>
        <div [innerHTML]="data.mensagem"></div>
    </div>
    <div class="modal-actions" mat-dialog-actions align="end">
        <button mat-flat-button color="primary" mat-dialog-close>OK</button>
    </div>
</div>